export default __webpack_public_path__ + "static/media/logo-2.8d8944f9.svg";